import apiClient from './apiClient';

const productsService = {
  // Get all products for the current authenticated user
  getProducts: async () => {
    const response = await apiClient.get('/products');
    return response.data;
  },
  
  // Get all products for current authenticated user
  getMerchantProducts: async () => {
    // Session-based: uses authenticated user from req.user
    const response = await apiClient.get('/products');
    return response.data;
  },
  
  // Get single product by ID
  getProduct: async (productId) => {
    const response = await apiClient.get(`/products/${productId}`);
    return response.data;
  },
  
  // Create a new product
  createProduct: async (data) => {
    const response = await apiClient.post('/products', data);
    return response.data;
  },
  
  // Update a product
  updateProduct: async (productId, data) => {
    const response = await apiClient.put(`/products/${productId}`, data);
    return response.data;
  },
  
  // Delete a product
  deleteProduct: async (productId) => {
    const response = await apiClient.delete(`/products/${productId}`);
    return response.data;
  },

  // ─── Variant API ────────────────────────────────────────────────────────────

  // Get all variants for a product
  getVariants: async (productId) => {
    const response = await apiClient.get(`/products/${productId}/variants`);
    return response.data;
  },

  // Create a variant on a product
  createVariant: async (productId, data) => {
    const response = await apiClient.post(`/products/${productId}/variants`, data);
    return response.data;
  },

  // Update a variant
  updateVariant: async (productId, variantId, data) => {
    const response = await apiClient.put(`/products/${productId}/variants/${variantId}`, data);
    return response.data;
  },

  // Delete a variant
  deleteVariant: async (productId, variantId) => {
    const response = await apiClient.delete(`/products/${productId}/variants/${variantId}`);
    return response.data;
  }
};

export default productsService;